import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readTripRegions, deleteTripRegion } from '../actions/entity.trip.region';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';

function TripRegions(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);

    const deleteTripRegionAction = (id) => {
        dispatch(deleteTripRegion(params.entityId, id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('tripRegions.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('tripRegions.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('tripRegions.columns.status.enabled');
                } else {
                    return t('tripRegions.columns.status.disabled');
                }
            }
        },
        {
            title: t('tripRegions.columns.excludeFromMenu'),
            dataIndex: 'excludeFromMenu',
            key: 'excludeFromMenu',
            render: (text, record) => {
                if (typeof record.excludeFromMenu !== 'undefined' && record.excludeFromMenu === true) {
                    return t('tripRegions.columns.excludeFromMenu.enabled');
                } else {
                    return t('tripRegions.columns.excludeFromMenu.disabled');
                }
            }
        },
        {
            title: t('tripRegions.columns.order'),
            dataIndex: 'order',
            key: 'order',
        },
        {
            title: t('tripRegions.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('tripRegions.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button size="small" type="primary" href={`/entity/${params.entityId}/trip-region/${record.id}`}>{t('tripRegions.actions.edit')}</Button>
                <Popconfirm
                    title={t('tripRegions.actions.delete-confirm')}
                    onConfirm={() => deleteTripRegionAction(record.id)}
                    okText={t('tripRegions.actions.delete-ok')}
                    cancelText={t('tripRegions.actions.delete-cancel')}
                >
                    <Button size="small" type="primary" danger>{t('tripRegions.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readTripRegions(params.entityId)).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch, params.entityId]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate(`/entity/${params.entityId}/dashboard`)}
                        title={t('tripRegions.title')}
                        subTitle={t('tripRegions.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={`/entity/${params.entityId}/trip-region`}>{t('tripRegions.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        size='small'
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default TripRegions;